import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import Home from './pages/home';
import Header from './components/Header';
import { useAuth } from './context/AuthContext';
import Signup from './pages/signup';
import './styles/App.css';

import ResetPassword from './pages/ResetPassword';
import CheckUserName from './pages/CheckUserName';
import CompleteSetupModal from './components/CompleteSetupModal';

const AppRoutes = () => {
  const { isAuthenticated, username } = useAuth();

  return (
    <Router>
      <Header />
      <CompleteSetupModal key={username || "setup"} />
      <div className="page-content">
        <Routes>
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/home" /> : <Login />}
          />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/home"
            element={isAuthenticated ? <Home key={username} /> : <Navigate to="/" />}
          />
        <Route path="/forgotPassword" element={<CheckUserName />} />
        <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
};

export default AppRoutes;
